import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setUser } from '../feature/user.Slice';
import { useNavigate } from 'react-router-dom';
import HidePasswordIcon from '../components/HidePasswordIcon';

const RECAPTCHA_SITE_KEY = '6LfxufopAAAAAMPi3djhkNECTCscbUN9s60zfAm6';

const apiPrefix = process.env.REACT_APP_API_PREFIX;

const regexEmail = /^[^@\s]{2,30}@[^\s@]{2,30}\.[^@\s]{2,}$/;

const regexPassword = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*\-+.]).{8,}$/;

const Signin = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/enterprise.js?render=${RECAPTCHA_SITE_KEY}`;
        script.async = true;
        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, []);

    const submitLogin = async (recaptchaToken) => {
        const normalizedUsername = username.toLowerCase();

        const formData = {
            username: normalizedUsername,
            password: password,
            token: recaptchaToken,
        };

        const response = await fetch(apiPrefix + 'login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        });

        if (response.ok) {
            const data = await response.json();

            if (data.user.active) {
                dispatch(setUser({ user: data.user, token: data.token }));
                navigate('/');
            } else {
                setError("Veuillez contacter notre support à l'adresse suivante : contact@ca-cpourmoi.com .");
            }
        } else {
            const data = await response.json().catch(() => ({}));
            setError(data.error || "Nom d'utilisateur ou mot de passe incorrect");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        const normalizedUsername = username.toLowerCase();

        if (!regexEmail.test(normalizedUsername)) {
            setError("Le nom d'utilisateur doit être une adresse e-mail valide.");
            return;
        }
        if (!regexPassword.test(password)) {
            setError("Le mot de passe doit contenir au moins 8 caractères, dont une majuscule, une minuscule, un chiffre et un caractère spécial.");
            return;
        }

        if (window.grecaptcha && window.grecaptcha.enterprise) {
            window.grecaptcha.enterprise.ready(async () => {
                try {
                    const token = await window.grecaptcha.enterprise.execute(RECAPTCHA_SITE_KEY, { action: 'LOGIN' });
                    await submitLogin(token);
                } catch (error) {
                    console.error('Erreur:', error);
                    setError("Une erreur est survenue lors de la connexion.");
                }
            });
        } else {
            setError('reCAPTCHA not ready or not available');
        }
    };

    const handleForgotPassword = () => {
        navigate('/forgot');
    };

    return (
        <div className="flex flex-col items-center justify-center bg-gray-50 p-5 min-h-screen">
            <h2 className="text-gray-800 text-2xl font-bold mb-5">Connexion</h2>
            {error && <div className="alert alert-error text-center mb-4">{error}</div>}
            <form onSubmit={handleSubmit} className="card w-full max-w-md">
                <div className="form-group">
                    <label htmlFor="username" className="form-label">
                        <i className="fas fa-envelope mr-2.5 text-primary"></i>
                        Mail d'utilisateur :
                    </label>
                    <input
                        type="text"
                        id="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                        className="form-input"
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="password" className="form-label">
                        <i className="fas fa-key mr-2.5 text-primary"></i>
                        Mot de passe :
                    </label>
                    <div className="relative">
                        <input
                            type={showPassword ? 'text' : 'password'}
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="form-input h-10"
                        />
                        <HidePasswordIcon showPassword={showPassword} setShowPassword={setShowPassword} />
                    </div>
                </div>
                <button
                    type="submit"
                    className="btn-primary w-full mt-5"
                >
                    Se connecter
                </button>
                <button
                    type="button"
                    className="btn-secondary w-full mt-2.5"
                    onClick={handleForgotPassword}
                >
                    Mot de passe oublié ?
                </button>
            </form>
        </div>
    );
};

export default Signin;
